module.exports = __webpack_public_path__ + "img/img06.a8aa2697.jpg";